import * as React from 'react';

import { Box, Button, TextRow, Typography } from 'components';

import { AddressInput } from '../AddressInput';
import { CityInput } from '../CityInput';
import { Currency } from 'enums';
import { NameInput } from '../NameInput';
import { TEXT } from 'texts';
import { formatAmount } from 'utils';
import { observer } from 'mobx-react-lite';
import { paths } from 'routing';
import { useHistory } from 'react-router';
import { useStores } from 'hooks';
import { useTranslation } from 'react-i18next';

const TransferForm = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const { formStore, dataStore } = useStores();

  React.useEffect(() => {
    if (!dataStore.transferData.needExtraData) {
      history.push(paths.main);
    }
  }, [dataStore.transferData.needExtraData, history]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    formStore.validate(['address', 'name', 'city']);
    if (formStore.isTransferValid) {
      history.push(paths.transferConfirm);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box pt={1}>
        <Typography textType="title" textColor="black" align="center" fontWeight={600}>
          {t(TEXT.transferDetails)}
        </Typography>
      </Box>
      <Box mt={4}>
        <TextRow title={t(TEXT.transferDirection)} subtitle={dataStore.transferData.country} />
      </Box>
      <Box mt={4}>
        <TextRow title={t(TEXT.amount)} text={`${formatAmount({ amount: formStore.amount.value })} ${Currency.UAH}`} />
      </Box>
      <Box mt={4}>
        <TextRow
          title={t(TEXT.commission)}
          text={dataStore.transferData.commission}
          subtext={dataStore.transferData.minCommission}
        />
      </Box>
      <Box mt={4}>
        <TextRow title={t(TEXT.comment)} subtitle={dataStore.appData?.recipient.purposeText} />
      </Box>
      <Box pt={3}>
        <Typography textType="title" textColor="black" align="center" fontWeight={600}>
          {t(TEXT.addInfo)}
        </Typography>
      </Box>
      <Box pt={2}>
        <Typography textType="text" textColor="grey" align="center">
          {t(TEXT.transferHelper)}
        </Typography>
      </Box>
      <Box mt={1}>
        <CityInput />
      </Box>
      <Box mt={1}>
        <AddressInput />
      </Box>
      <Box mt={1}>
        <NameInput />
      </Box>
      <Box pt="40px" mt={'auto'}>
        <Button buttonType="round" background="gradient" fullWidth type="submit">
          <Typography textType="button" textColor="white">
            {t(TEXT.send)}
          </Typography>
        </Button>
      </Box>
    </form>
  );
};

export default observer(TransferForm);
